"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var $ = require("jquery");
require("slick-carousel");
var tab_1 = require("../../modules/tab");
require("magnific-popup");
var shopPageIndex = /** @class */ (function () {
    function shopPageIndex(isAjax) {
        this.$slider = null;
        if (!isAjax) {
            this.$slider = $('.js-card-slider');
            this.initCardSlider();
            tab_1.default.getInstance();
        }
    }
    shopPageIndex.getInstance = function (isAjax) {
        if (isAjax === void 0) { isAjax = false; }
        return new shopPageIndex(isAjax);
    };
    shopPageIndex.prototype.initCardSlider = function () {
        var $slider = this.$slider, options = {
            mobileFirst: true,
            slidesToShow: 1,
            slidesToScroll: 1,
            prevArrow: '<button class="slick-prev"><span></span></button>',
            nextArrow: '<button class="slick-next"><span></span></button>',
            responsive: [
                {
                    breakpoint: 540,
                    settings: {
                        slidesToShow: 2,
                        slidesToScroll: 2
                    }
                },
                {
                    breakpoint: 768,
                    settings: {
                        slidesToShow: 3,
                        slidesToScroll: 3
                    }
                },
                {
                    breakpoint: 1024,
                    settings: {
                        slidesToShow: 4,
                        slidesToScroll: 4
                    }
                }
            ]
        }, _self = this;
        if ($slider.length <= 0) {
            _self.initCardModal();
            return;
        }
        $slider.each(function () {
            $(this).on('setPosition', function () {
                _self.initCardModal();
            });
            $(this).slick(options);
        });
    };
    shopPageIndex.prototype.initCardModal = function () {
        var $card = $('.js-card'), $body = $('html'), $window = $(window), scrollPosition;
        $card.magnificPopup({
            type: 'image',
            image: {
                markup: '<div class="mfp-figure">' +
                    '<div class="mfp-img"></div>' +
                    '<div class="mfp-btn-wrapper">' +
                    '<p><a href="#" class="btn mfp-next-btn"><span>' + STORE.trans.selectPostcard + '</span><span class="bg"></span></a></p>' +
                    '<div class="mfp-close"></div>' +
                    '</div>' +
                    '</div>',
                cursor: null,
                verticalFit: true,
                tError: '<a href="%url%">The image</a> could not be loaded.'
            },
            closeMarkup: '<button type="button" class="mfp-close">' + STORE.trans.close + '</button>',
            callbacks: {
                markupParse: function (template, values, item) {
                    template.find('a').attr('href', item.el.data('url'));
                },
                open: function () {
                    setTimeout(function () {
                        $('.mfp-figure').addClass('open');
                    }, 50);
                    $body.addClass('no-scroll');
                },
                close: function () {
                    $body.removeClass('no-scroll');
                    $window.scrollTop(scrollPosition);
                },
                beforeOpen: function () {
                    scrollPosition = $window.scrollTop();
                },
            }
        });
    };
    return shopPageIndex;
}());
exports.default = shopPageIndex;
